/**
 * @generated SignedSource<<0352106474ba82776c52c63cbc129221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogOverview_catalogPage$data = {
  readonly file: {
    readonly filePath: string | null;
  } | null;
  readonly images: {
    readonly pageCount: number | null;
    readonly prefix: string | null;
    readonly singlePageDimensions: {
      readonly height: number;
      readonly width: number;
    };
  } | null;
  readonly title: string | null;
  readonly " $fragmentType": "CatalogOverview_catalogPage";
};
export type CatalogOverview_catalogPage$key = {
  readonly " $data"?: CatalogOverview_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogOverview_catalogPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogOverview_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogFileModuleType",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filePath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogImagesType",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CatalogImagesDimensions",
          "kind": "LinkedField",
          "name": "singlePageDimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};

(node as any).hash = "111575007f5e8bf55670c535f7c50288";

export default node;
